'use strict';
/* eslint-disable linebreak-style */
/* eslint-disable linebreak-style */
/* eslint-disable max-len */
/* eslint-disable vars-on-top */
/* eslint-disable indent */
/* eslint-disable linebreak-style */

// Front check if the user is logged in (Usuario logeado)
function checkUserLoginStatus() {
    // Comprobar si el contenedor de información del cliente está presente
    var clientInfo = $('.cn_client_info');

    // Si el contenedor de información del cliente tiene una clave primaria (el correo electrónico del usuario) no vacío, el usuario está logueado
    if (clientInfo.length > 0 && clientInfo.find('.primary_key').text().trim() !== '') {
        // El usuario está logueado
        return true;
    } else {
        // El usuario no está logueado
        return false;
    }
}

// Modal Login
$('.wishlists-checkout-btn-sign-in').on('click', function () {
    const url = $(this).data('url');

    // Verifica si el modal ya existe en el DOM
    if ($('#modalGlobalRyk').length === 0) {
        // Si no existe, carga y agrega el modal
        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                // Agrega el HTML del modal al body
                $('body').append(response); // Agrega el modal al DOM

                // Abre el modal
                $('#modalGlobalRyk').modal('show');
            },
            error: function () {
                console.error('No se pudo cargar el modal de inicio de sesión.');
            }
        });
    } else {
        // Si ya existe, solo ábrelo
         $(".backgroundCtn").toggleClass('d-none');
    }
});

function changeIcon(data) {
    $.spinner().stop();
    var pid = data.pid;
    var addButton = $('#add-heart-' + pid);
    var removeButton = $('#remove-heart-' + pid);
    if (data.success) {
        addButton.removeClass('show-flex');
        removeButton.addClass('show-flex');
    } else if (data.exists) {
            addButton.removeClass('show-flex');
            removeButton.addClass('show-flex');
        } else {
            var status = 'alert-danger';
            if ($('.add-to-wishlist-messages').length === 0) {
                $('body').append(
                    '<div class="add-to-wishlist-messages "></div>'
                );
            }
            $('.add-to-wishlist-messages').empty();
            $('.add-to-wishlist-messages')
                .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

            setTimeout(function () {
                $('.add-to-wishlist-messages').remove();
            }, 5000);
        }
}
function changeIconRemove(data) {
    $.spinner().stop();
    var pid = data.pid;
    var addButton = $('#add-heart-' + pid);
    var removeButton = $('#remove-heart-' + pid);
    if (data.success) {
        addButton.addClass('show-flex');
        removeButton.removeClass('show-flex');
    }
}
function updateButtons(productIds) {
    if (productIds && productIds.length > 0) {
        for (var index = 0; index < productIds.length; index++) {
            var pid = productIds[index];
            var addButton = $('#add-heart-' + pid);
            var removeButton = $('#remove-heart-' + pid);
            addButton.removeClass('show-flex');
            removeButton.addClass('show-flex');
        }
    }
}

function addWishListButton() {
        $('body').on('click', '.add-wish-button', function (e) {
            if (!checkUserLoginStatus()) {
              $(".backgroundCtn.wishlistModal").toggleClass('d-none');
              return;
            }
            e.preventDefault();
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    changeIcon(data);
                    updateWishlistProductCount(data.currentList);
                    $.spinner().stop();
                },
                error: function (err) {
                    changeIcon(err);
                }
            });
        });
    }
function removeWishlistButton() {
        $('body').on('click', '.remove-wish-button', function (e) {
            e.preventDefault();
            var url = $(this).data('url');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {},
                success: function (data) {
                    changeIconRemove(data);
                    updateWishlistProductCount(data.currentList);
                    $.spinner().stop();
                },
                error: function (err) {
                    $.spinner().stop();
                }
            });
        });
    }

function updateHeartButtons(load) {
        if (load) {
            var input = $('#heartbutton-list');
            var url = input.val();
            if (url) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function (data) {
                        $.spinner().stop();
                        if (data.active) {
                            updateButtons(data.productIds);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        }
    }

function updateWishlistProductCount(url) {
   try {
    if (url) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          data: {},
        }).
        done(function (data) {
          $('.wishlist-account-amount').text(data.amountPdtWishlist);
        })
        .fail(function (error) {
          console.error('Error [wishlist][removeFromWishlist]: {0}', error.message);
          $('.wishlist-account-card').spinner().stop();
        });
    }
  } catch (error) {
    console.error('Error [wishlist][removeFromWishlist]: {0}', error.message);
  }
}


module.exports = {
  addWishListButton,
  removeWishlistButton,
  updateHeartButtons,
  updateWishlistProductCount
};
